export const AGORA_APP_ID = '09a25dfc30f94778bff392f6beb0bef1' // set your app id here